import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Star } from "lucide-react";
import {
  Zap, Sparkles, Clock, Wind, Eye, Heart, Lock, Repeat,
  HelpCircle, Search, Brain, MessageCircle, Users, TrendingUp
} from "lucide-react";

const ICON_MAP = { Zap, Sparkles, Clock, Wind, Eye, Heart, Lock, Repeat, HelpCircle, Search, Brain, MessageCircle, Users, TrendingUp };
export const getIcon = (name) => ICON_MAP[name] || Star;

export const ExerciseCard = ({ exercise }) => {
  const IconComp = getIcon(exercise.icon);
  return (
    <Link to={`/exercises/${exercise.id}`} className="group block" data-testid={`exercise-card-${exercise.id}`}>
      <div className="bg-white rounded-3xl border border-[#EBE7E0] p-5 hover:shadow-[0_10px_40px_rgba(44,53,49,0.08)] transition-all duration-300 h-full">
        <div className="flex items-start gap-3.5">
          <div className="w-11 h-11 rounded-2xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110" style={{ backgroundColor: exercise.color + '18' }}>
            <IconComp className="w-5 h-5" style={{ color: exercise.color }} strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-[#2C3531] group-hover:text-[#6B8576] transition-colors duration-300" style={{ fontFamily: 'Outfit' }}>{exercise.title}</h3>
            {exercise.subtitle && <p className="text-xs text-[#6A7771] mt-0.5">{exercise.subtitle}</p>}
            <p className="text-sm text-[#6A7771] mt-1.5 line-clamp-2 leading-relaxed">{exercise.objective}</p>
          </div>
          <ChevronRight className="w-5 h-5 text-[#EBE7E0] group-hover:text-[#6B8576] group-hover:translate-x-1 transition-all duration-300 flex-shrink-0 mt-1" strokeWidth={1.5} />
        </div>
      </div>
    </Link>
  );
};
